/// <amd-module name="Test/TestPlansHubRefresh/TestCasesImportModule/Redux/TestCasesImportPanelActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";

export const TestCasesImportPanelActions = {
    /**
     * csvFileAdded: this action is dispatched to update the flag for evaluating if csv file has been chosen as input
     */
    csvFileAdded: (isCSVFileSelected: boolean) => createAction(TestCasesImportPanelActionsTypes.csvFileAdded, isCSVFileSelected),

    /**
     * updateLoadingState: this action is dispatched to update the spinner state
     */
    updateLoadingState: (isLoading: boolean, percentComplete: number) =>
        createAction(TestCasesImportPanelActionsTypes.updateLoadingState, { isLoading, percentComplete }),

    /**
     * showErrorMessages: this action is dispatched to show any error messages while import is in progress
     */
    showErrorMessages: (errorMessage: string) => createAction(TestCasesImportPanelActionsTypes.showErrorMessages, errorMessage)
};

export const enum TestCasesImportPanelActionsTypes {
    csvFileAdded = "TestCasesImportPanel/csvFileAdded",
    updateLoadingState = "TestCasesImportPanel/updateLoadingState",
    showErrorMessages = "TestCasesImportPanel/showErrorMessages"
}

export type TestCasesImportPanelActions = ActionsUnion<typeof TestCasesImportPanelActions>;
